$(function () {
  $('.fv_fade')
    // 最初のスライドに"add-animation"のclassを付ける(data-slick-index="0"が最初のスライドを指す)
    .on("init", function () {
      $('.fv_fade .slick-slide[data-slick-index="0"]').addClass("add-animation");
    })
    .slick({
      fade: true,    // fedeオン
      speed: 1500,   // 画像切り替えにかかる時間（ミリ秒）
      autoplaySpeed: 5000,   // 自動スライド切り替え速度  });
      autoplay: true,        // 自動再生
      slidesToShow: 1,       // スライド表示数
      slidesToScroll: 1,     // スライドする数
      infinite: true,         // 無限リピート オン・オフ
    })
    .on({
      // スライドが移動する前に発生するイベント
      beforeChange: function (event, slick, currentSlide, nextSlide) {
        // 表示されているスライドに"add-animation"のclassをつける
        $(".slick-slide", this).eq(nextSlide).addClass("add-animation");
        // あとで"add-animation"のclassを消すための"remove-animation"classを付ける
        $(".slick-slide", this).eq(currentSlide).addClass("remove-animation");
      },
      // スライドが移動した後に発生するイベント
      afterChange: function () {
        // 表示していないスライドはアニメーションのclassを外す
        $(".remove-animation", this).removeClass(
          "remove-animation add-animation"
        );
      },
    });
  $('.slick_auto').slick({
    autoplay: true, // 自動でスクロール
    autoplaySpeed: 0, // 自動再生のスライド切り替えまでの時間を設定
    speed: 10000, // スライドが流れる速度を設定
    cssEase: "linear", // スライドの流れ方を等速に設定
    slidesToShow: 4, // 表示するスライドの数
    swipe: false, // 操作による切り替えはさせない
    arrows: false, // 矢印非表示
    pauseOnFocus: false, // スライダーをフォーカスした時にスライドを停止させるか
    pauseOnHover: false, // スライダーにマウスホバーした時にスライドを停止させるか
    responsive: [{
      breakpoint: 768, // 767px以下に適用
      settings: {
        slidesToShow: 1.8,
      }
    }]
  })
  $('.acordion_box .title').on('click', function () {
    $(this).toggleClass('open');
    $(this).next('.text').slideToggle();
  })
  $('.slick_lineup').slick({
    slidesToShow: 4,       // スライド表示数
    slidesToScroll: 1,     // スライドする数
    arrows: true, // 矢印非表示
    infinite: false,
    dots: true,
    responsive: [{
      breakpoint: 1000,
      settings: {
        slidesToShow: 3,
        arrows: false,
      }
    },
    {
      breakpoint: 768, // 767px以下に適用
      settings: {
        slidesToShow: 1,
        arrows: false,
      }
    }]
  });
})

$('.slick_guide').slick({
  arrows: false, // 矢印非表示
  slidesToShow: 3,       // スライド表示数
  swipe: false, // 操作による切り替えはさせない
  arrows: false, // 矢印非表示
  responsive: [{
    breakpoint: 768, // 767px以下に適用
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,     // スライドする数
      swipe: true, // 操作による切り替えはさせない
      arrows: true, // 矢印非表示
      dots: true,
    }
  }]
});

$(window).scroll(function () {
  $('.fadein').each(function () {
    var elemPos = $(this).offset().top,
      scroll = $(window).scrollTop(),
      windowHeight = $(window).height();

    if (scroll > elemPos - windowHeight + 150) {
      $(this).addClass('scrollin');
    }
  });
});

$(function () {
  $(".info h3").each(function () {
    var item_name = $(this).text();
    var item_name_before = item_name.slice(0, item_name.indexOf("】") + 1);
    var item_name_after = item_name.slice(item_name.indexOf("】") + 1);
    var item_list_name = item_name_before + "<br>" + item_name_after;
    $(this).html(item_list_name);
  });
});